module.exports = __webpack_public_path__ + "img/Coloca_Pega Pisos.9faab5c2.png";